import React from 'react';
import ReactDOM from 'react-dom/client';
import '@carbon/styles/css/styles.css';
import { Theme } from '@carbon/react';
import App from './App';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Theme theme="white">
      <App />
    </Theme>
  </React.StrictMode>
);
